const getSearchParams = (showGoBackButton: boolean) => ({
  context: 'feed',
  hide_title: 'true',
  show_go_back_button: `${showGoBackButton}`,
});

/* eslint-disable camelcase */
const ROUTES = {
  posts_feed_post: Routes.feed_post_path,
  trip: Routes.trip_path,
  current: Routes.check_in_path,
};

export const getLinkUrlToPostItem = (
  type: string,
  id: number,
  {
    showGoBackButton = true,
    topicId,
  }: { showGoBackButton?: boolean; topicId?: number | null } = {
    showGoBackButton: true,
  },
) => {
  const searchParams = getSearchParams(showGoBackButton);

  // @TODO refactor this do not use ROUTES object
  if (topicId && type === 'posts_feed_post') {
    return Routes.topic_topic_feed_posts_path(topicId, id, searchParams);
  }

  return ROUTES[type] ? ROUTES[type](id, searchParams) : '#';
};
